<div class="row row-gutters">
  @if (Cards$ | async; as cards) {
    @for (card of cards; track card) {
      <div class="col col-xs-12 col-md-4">
        <local-seo-primary-source
          [data]="card"
          [sidebarTopPadding]="sidebarTopPadding"
          [isListingfromEmbedded]="isListingfromEmbedded"
        ></local-seo-primary-source>
      </div>
    }
  } @else {
    @for (src of cardSources; track src) {
      <div class="col col-xs-12 col-md-4">
        <mat-card>
          <mat-card-content>
            <div class="shimmer">
              <div class="stencil-shimmer"></div>
              <div class="stencil-shimmer"></div>
              <div class="stencil-shimmer"></div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    }
  }
</div>
